<template>
	<dialog-slot
			title="Actions"
			@updateClose="onDrawerClose"
			:is-show-button-groups="false"
			width="800px"
	>
		<no-info
				v-if="items && items.length <= 0"
				padding="0"
				text="This driver has no actions yet."
		/>
		<main-table
				v-else
				padding="0"
				flag="UserListActions"
				:headers="getHeaders"
				:listItems="items"
				:filtersList="{}"
				:is-hide-header="false"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateClickButton="onClickButton"
		></main-table>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";
import { UserListActions } from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";

export default {
	name: "UserListActions",
	components: { NoInfo, DialogSlot },
	computed: {
		getHeaders() {
			return UserListActions;
		}
	},
	props: {
		items: Array,
	},
	methods: {
		onDrawerClose() {
			this.$emit("updateCloseDialog");
		},
		onClickButton(args) {
			this.$emit("updateClickButton", args);
		},
	},
};
</script>

<style scoped lang="scss"></style>
